import { Button, CircularProgress } from "shared";
import { authContext } from "entities/user";
import React, { useContext } from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import styles from "./document_external_form.module.scss";


interface IDocumentExternalFormProps {
    savingExternal: boolean;
    onSaveExternalForm: () => void;
}

export const DocumentExternalForm: React.FC<IDocumentExternalFormProps> = React.memo(({
                                                                                          savingExternal,
                                                                                          onSaveExternalForm,
                                                                                      }) => {
    const t = useComponentsTranslations();
    const userInfo = useContext(authContext);

    return userInfo?.isExternal ?
        <div className={styles.externalSaveBtn}>
            <Button className={styles.button}
                    view="legal"
                    disabled={savingExternal}
                    onClick={onSaveExternalForm}>
                <div className={styles.buttonInnerContainer}>
                    {t("save")}
                    {savingExternal &&
                        <CircularProgress size={15} className={styles.loader}/>}
                </div>
            </Button>
        </div> : null;
});
